import React from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { ARENA_PROFILE_PAGE_URL } from '../../../utils/constants';
import isServer from '../../../utils/isServer';

const mapStateToProps = ({ initialData, router }) => ({
  arenaUserInfo: initialData.arenaUserInfo,
  router,
});

class RedirectMyProfileToProfilePage extends React.Component {
  static fetchData(store, match, staticContext) {
    const {
      initialData: { arenaUserInfo },
    } = store.getState();
    if (isServer && staticContext) {
      staticContext.status = 302;
      staticContext.redirectUrl = `${ARENA_PROFILE_PAGE_URL}/${arenaUserInfo.userName}`;
    }
    return Promise.resolve();
  }

  render() {
    return (
      <Redirect
        to={`${ARENA_PROFILE_PAGE_URL}/${this.props.arenaUserInfo.userName}`}
      />
    );
  }
}
const ConnectedRedirectMyProfileToProfilePage = connect(
  mapStateToProps,
  {},
)(RedirectMyProfileToProfilePage);

export default ConnectedRedirectMyProfileToProfilePage;
